import { render } from "./NotFound.vue?vue&type=template&id=07ac009a"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./NotFound.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__